import './RememberMe.css';

import { useLanguageContext } from '../../core/locale/LanguageContext';
import React from 'react';
import { useFlag } from '../../feature-flags';

interface RememberMeProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

function RememberMe(props: RememberMeProps): React.ReactNode {
  const rememberMeEnabled = useFlag('rememberMeEnabled');
  const languageContext = useLanguageContext();
  const labelText = languageContext.getLocalizedText('rememberMeLabel');

  if (!rememberMeEnabled) {
    return <div className="checkbox"></div>; // Placeholder
  }

  return (
    <div className={`checkbox ${props.value ? 'checked' : 'unchecked'}`}>
      <input
        id="remember-me-checkbox"
        data-testid="remember-me-checkbox"
        className="input"
        type="checkbox"
        checked={props.value}
        onChange={(e) => props.onChange(e.target.checked)}
      />
      <div className="box"></div>
      <label className="label" htmlFor="remember-me-checkbox">
        {labelText}
      </label>
    </div>
  );
}

export default RememberMe;
